import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EtiquetaMascarelloModule } from '../etiqueta-mascarello/etiqueta-mascarello.module';
import { ModalEtiquetaMascarelloComponent } from './modal-etiqueta-mascarelo.component';

@NgModule({
  declarations: [
    ModalEtiquetaMascarelloComponent
  ],
  imports: [
    CommonModule,
    EtiquetaMascarelloModule,
    ModalModule.forRoot()
  ],
  exports: [
    ModalEtiquetaMascarelloComponent
  ]
})
export class ModalEtiquetaMascarelloModule { }
